import React from "react";
import Orders from "./pages/Order/orders.js";
import Chat from "./pages/Chat/index.js";
import Menu from "./pages/Menu/menu.js";
import Ordering from "./pages/Menu/ordering.js";
import Schedule from "./pages/Schedule/schedule.js";
import Layout from "./layouts/layout.js";
import Profile from "./pages/Profile/index.js";
import Login from "./pages/login.js";
import NotFound from "./pages/notFound.js";
import Payments from "./pages/Payments/index.js";
import TelegramPayments from "./pages/Payments/TelegramPayments.js";
import { Route, Routes, Navigate } from "react-router-dom";
import AuthGuard from "./components/Guard/AuthGuard.js";
import OrderContent from "./pages/Order/orderContent.js";
import OrderDetailsExternal from "./pages/Order/orderDetailsExternal.js";
import OrderBoard from "./pages/Order/board.js";
import LoadingSpinner from "./components/LoadingSpinner/loadingSpinner.js";
import Promocodes from "./pages/Promocodes/index.js";
import Development from "./pages/Development/index.js";
import Clients from "./pages/Clients/index.js";
import Configurations from "./pages/Configurations/index.js";
import Integrations from "./pages/Integrations/index.js";
import { useAuth } from "./utils/authContext.js";

/**
 * RootRedirect component - Redirects to appropriate page based on auth status
 * @returns {JSX.Element} Redirect component
 */
const RootRedirect = () => {
    const { isAuthenticated, isLoading } = useAuth();

    if (isLoading) {
        return (
            <div className="h-screen w-full flex flex-col items-center justify-center bg-gray-50 dark:bg-[#0d1117]">
                <LoadingSpinner />
            </div>
        );
    }

    return isAuthenticated ? <Navigate to="/orders" replace /> : <Navigate to="/login" replace />;
};

const PaymentsPathGate = () => {
    const { chefData } = useAuth();
    const hasTelegramBot = chefData?.hasTelegramBot === true;
    if (hasTelegramBot) {
        return <Navigate to="/telegram-payments" replace />;
    }
    return <Payments />;
};

const TelegramPaymentsPathGate = () => {
    const { chefData } = useAuth();
    const hasTelegramBot = chefData?.hasTelegramBot === true;
    if (!hasTelegramBot) {
        return <Navigate to="/payments" replace />;
    }
    return <TelegramPayments />;
};

const AppRoutes = () => {
    return (
        <Routes>
            {/* Root path - redirect based on authentication status */}
            <Route path="/" element={<RootRedirect />} />

            <Route path="/login" element={<Login />} />
            <Route
                path="/*"
                element={
                    <AuthGuard>
                        <Layout />
                    </AuthGuard>
                }
            >
                <Route path="orders" element={<Orders />} />
                <Route path="orders/board" element={<OrderBoard />} />
                <Route path="orders/external/:orderNumber" element={<OrderDetailsExternal />} />
                <Route path="orders/:orderId" element={<OrderContent />} />
                <Route path="chat" element={<Chat />} />
                <Route path="menu/ordering" element={<Ordering />} />
                <Route path="menu/*" element={<Menu />} />
                <Route path="schedule" element={<Schedule />} />
                <Route path="profile" element={<Profile />} />
                <Route path="payments" element={<PaymentsPathGate />} />
                <Route path="telegram-payments" element={<TelegramPaymentsPathGate />} />
                <Route path="promocodes" element={<Promocodes />} />
                <Route path="promocodes/create" element={<Promocodes />} />
                <Route path="promocodes/edit/:id" element={<Promocodes />} />
                <Route path="clients" element={<Clients />} />
                <Route path="configurations" element={<Configurations />} />
                <Route path="integrations" element={<Integrations />} />
                <Route path="development" element={<Development />} />
            </Route>

            <Route path="*" element={<NotFound />} />
        </Routes>
    );
};

export default AppRoutes;
